import React from 'react';
import '../../news-pages.css'
import Parse from 'html-react-parser'

import OwlCarousel from 'react-owl-carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'

import cover from './cover.jpg'
import pic0 from './pic0.jpg'
import pic1 from './pic1.jpg'
import pic2 from './pic2.jpg'
import pic3 from './pic3.jpg'
import pic4 from './pic4.jpg'
import pic5 from './pic5.jpg'
import pic6 from './pic6.jpg'
import pic7 from './pic7.jpg'
import pic8 from './pic8.jpg'
import pic9 from './pic9.jpg'
import pic10 from './pic10.jpg'
import pic11 from './pic11.jpg'
import pic12 from './pic12.jpg'
import pic13 from './pic13.jpg'
import pic14 from './pic14.jpg'
import pic15 from './pic15.jpg'
import pic16 from './pic16.jpg'
import pic17 from './pic17.jpg'
import pic18 from './pic18.jpg'
import pic19 from './pic19.jpg'



const Id2 = () => {

    const detail = 
        {
            id:32,
            imgSrc:cover,
            ini:'Training SATIT Primary School Students on Zoonoses (Final Day)',
            href:'',
            element:'',
            topic:`The LUCENT International Cooperation Unit, in collaboration with the IJL PRESTO International Joint Laboratory Project, held the final day of activities on Monday, July 6, 2026, to review and consolidate the knowledge gained on zoonotic disease prevention through a quiz-based activity summarizing what students had learned over the four days of the program.
                    Throughout the program, the participatory learning activities helped build essential knowledge, understanding, and skills in zoonotic disease prevention, fostering critical thinking, hands-on practice, teamwork, and leadership development. These activities aimed to equip students to become knowledge ambassadors, promoting appropriate disease-prevention behaviors among their friends, families, and communities — in line with the program's goal of promoting learning and raising awareness of zoonotic diseases.
                    Finally, the LUCENT International Cooperation Unit and the IJL PRESTO International Joint Laboratory Project would like to extend their sincere gratitude to the administrators, teachers, and staff of Chiang Mai University Demonstration School for their cooperation, support, and generosity in providing the venue for the activities, as well as to the Grade 3 students who participated with dedication throughout the program. Their contributions were instrumental in the program's success in achieving its objectives.`,
            inform:``,
            link1:`https://lucent.ams.cmu.ac.th/view_activity.html?id=53`,
        }
    
        const handleLink1 = () =>{
            window.open(detail.link1, '_blank', 'noreferrer')
        }

    const imgs = [
        {
            imageSrc: cover,
            alt: 'cover',
            title: 'cover',
            thumbnailImageSrc: cover
        },
        {
            imageSrc: pic0,
            alt: 'pic0',
            title: 'pic0',
            thumbnailImageSrc: pic0
        },
        {
            imageSrc: pic1,
            alt: 'pic1',
            title: 'pic1',
            thumbnailImageSrc: pic1
        },
        {
            imageSrc: pic2,
            alt: 'pic2',
            title: 'pic2',
            thumbnailImageSrc: pic2
        },
        {
            imageSrc: pic3,
            alt: 'pic3',
            title: 'pic3',
            thumbnailImageSrc: pic3
        },
        {
            imageSrc: pic4,
            alt: 'pic4',
            title: 'pic4',
            thumbnailImageSrc: pic4
        },
        {
            imageSrc: pic5,
            alt: 'pic5',
            title: 'pic5',
            thumbnailImageSrc: pic5
        },
        {
            imageSrc: pic6,
            alt: 'pic6',
            title: 'pic6',
            thumbnailImageSrc: pic6
        },
        {
            imageSrc: pic7,
            alt: 'pic7',
            title: 'pic7',
            thumbnailImageSrc: pic7
        },
        {
            imageSrc: pic8,
            alt: 'pic8',
            title: 'pic8',
            thumbnailImageSrc: pic8
        },
        {
            imageSrc: pic9,
            alt: 'pic9',
            title: 'pic9',
            thumbnailImageSrc: pic9
        },
        {
            imageSrc: pic10,
            alt: 'pic10',
            title: 'pic10',
            thumbnailImageSrc: pic10
        },
        {
            imageSrc: pic11,
            alt: 'pic11',
            title: 'pic11',
            thumbnailImageSrc: pic11
        },
        {
            imageSrc: pic12,
            alt: 'pic12',
            title: 'pic12',
            thumbnailImageSrc: pic12
        },
        {
            imageSrc: pic13,
            alt: 'pic13',
            title: 'pic13',
            thumbnailImageSrc: pic13
        },
        {
            imageSrc: pic14,
            alt: 'pic14',
            title: 'pic14',
            thumbnailImageSrc: pic14
        },
        {
            imageSrc: pic15,
            alt: 'pic15',
            title: 'pic15',
            thumbnailImageSrc: pic15
        },
        {
            imageSrc: pic16,
            alt: 'pic16',
            title: 'pic16',
            thumbnailImageSrc: pic16
        },
        {
            imageSrc: pic17,
            alt: 'pic17',
            title: 'pic17',
            thumbnailImageSrc: pic17
        },
        {
            imageSrc: pic18,
            alt: 'pic18',
            title: 'pic18',
            thumbnailImageSrc: pic18
        },
        {
            imageSrc: pic19,
            alt: 'pic19',
            title: 'pic19',
            thumbnailImageSrc: pic19
        },
    ]

    return (
        <div className='elements containers'>
            <div className="img-slicer">
                <OwlCarousel
                    className='owl-theme'
                    loop={true}
                    margin={10}
                    lazyLoad={true}
                    nav
                    items={1}
                    autoplay={true}
                    autoplayTimeout={3000}
                    autoplayHoverPause={true}
                    smartSpeed={1000}
                >
                    {imgs.map((img,index)=>(
                        <div className="item" key={index}><img src={img.imageSrc} alt="item" /></div>
                    ))}
                </OwlCarousel>
            </div>
            <div className="text">
                <h1>{detail.ini}</h1>
                <h2>{Parse(detail.topic)}</h2>
                <p>{Parse(detail.inform)}</p>
                <div className="btn">
                    <h2>MORE INFORMATION</h2>
                    <button onClick={handleLink1}>{detail.link1}</button>
                </div>
            </div>
        </div>
    );
}

export default Id2;
